import coreRoutes from '@glittr/frontend-core/src/routes';
import Home from './views/pages/index.vue';

export default {
  mode: 'history',
  base: process.env!.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/:tenant/:workspace/customer-installation',
      name: 'customer-installation',
      component: () => import('./views/pages/app/customerInstallation/list.vue'),
    },
    {
      path: '/:tenant/:workspace/customer-installation/create',
      name: 'customer-installation-create',
      component: () => import('./views/pages/app/customerInstallation/edit.vue'),
    },
    {
      path: '/:tenant/:workspace/customer-installation/:customerInstallationId/edit',
      name: 'customer-installation-edit',
      component: () => import('./views/pages/app/customerInstallation/edit.vue'),
    },
    {
      path: '/:tenant/:workspace/customer-uptime',
      name: 'customer-uptime',
      component: () => import('./views/pages/app/customerUptime/list.vue'),
    },
    {
      path: '/:tenant/:workspace/customer-uptime/:customerInstallationId/detail',
      name: 'customer-uptime-detail',
      component: () => import('./views/pages/app/customerUptime/detailList.vue'),
    },
    {
      path: '/:tenant/:workspace/customerTransaction',
      name: 'customerTransaction',
      component: () => import('./views/pages/app/customerTransaction/list.vue'),
    },
    ...coreRoutes,
    {
      path: '/:tenant/:workspace',
      name: 'dashboard',
      component: () => import('./views/pages/app/dashboard.vue'),
    },
  ],
};
